import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App.tsx'
import './fonts.css'

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: '#E04DA7',
      main: '#CC2085',
      dark: '#A31867',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"AlteHaasGroteskBold", "Helvetica", "Arial", sans-serif',
    fontWeightRegular: 700,
    fontWeightMedium: 700,
    fontWeightBold: 700,
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find the root element')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)